import { orderDocumentType } from "../utils/medicalDocument/documentTypes";
import MedicineForm from "./form/medicine";
import DateForm from "./form/Date";

export const orderModule = {
  ...orderDocumentType,
  MedicineForm,
  DateForm,
};
